import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Box, Typography, Card, CardContent } from '@mui/material';
import baseURL from '../config'; 
import CryptoJS from 'crypto-js';
import Cookies from 'js-cookie';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCoverflow, Pagination, Autoplay } from 'swiper';
import { useParams } from 'react-router-dom';
import './BannersMobile.css'

const getDecryptedToken = () => {
  const encryptedToken = Cookies.get("token");
  if (!encryptedToken) return null;

  const secretKey = '19092002'; 
  const bytes = CryptoJS.AES.decrypt(encryptedToken, secretKey);
  const decryptedToken = bytes.toString(CryptoJS.enc.Utf8);

  return decryptedToken || null;
};



const token = getDecryptedToken();

const arrayBufferToBase64 = (buffer) => {
  let binary = '';
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binary);
};

const BannersMobile = ({disabled}) => {
  const [banners, setBanners] = useState([]);
  const { theme } = useParams();

  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const response = await axios.get(`${baseURL}/api/Banner/GetAllBanners`, {
          
        });

        if (response.data.success === true) {
          const updatedBanners = response.data.banners.map((banner) => {
            return {
              ...banner,
              Image:
                typeof banner.image === 'string' ? banner.image : arrayBufferToBase64(banner.image),
            };
          });
          setBanners(updatedBanners);
        } else {
          toast.error('Ndodhi nje gabim ne marrjen e banerave');
        }
      } catch (error) {
        console.error('Error fetching banners', error);
        toast.error('Ndodhi nje gabim gjate marrjes se banerave.');
      }
    };

    fetchBanners();
  }, []);

  if (banners.length === 0) {
    return null; // Show nothing if no banners
  }

  //ngjyrat e dark edhe lightit = dark = #19191b, white

  const backgroundColor = theme === 'dark' ? '#2b2b30' : '#ffffff';

  return (
    <Box 
      sx={{ 
       width: '100%',
       height: '200px', 
       backgroundColor: backgroundColor,
       pointerEvents: 'none',
       touchAction: 'none',
       userSelect: 'none',
       overflow: 'clip',
      }}
    >
      <Swiper
        modules={[EffectCoverflow, Pagination, Autoplay]}
        spaceBetween={30}
        loop={true}
        autoplay={{
          delay: 1500, // Delay between slides in milliseconds
          disableOnInteraction: false, // Ensures autoplay doesn't stop after interaction
        }}
        pagination={{
          clickable: true,
        }}
        effect="coverflow"
        direction="horizontal" // Ensure the direction is horizontal
        coverflowEffect={{
          rotate: 0, // Rotate horizontally to ensure images are laid out horizontally
          stretch: 0,
          depth: 300,
          modifier: 1,
          slideShadows: true,
        }}
        centeredSlides={true}
        slidesPerView={2} // Default to show two slides at once
        breakpoints={{
          640: {
            slidesPerView: 2, // On small screens (under 640px), show two slides at once
          },
          768: {
            slidesPerView: 3, // On medium screens (under 768px), show three slides at once
          },
          1024: {
            slidesPerView: 4, // On larger screens, show four slides at once
          },
        }}
        allowTouchMove={false}
        simulateTouch={false}
        noSwiping={true}
        
      >
        {banners.map((banner) => (
          <SwiperSlide key={banner.bannerId}>
            <Card
              sx={{
                width: '100%',
                height: '190px',
                borderRadius: '16px',
                boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
                backgroundImage: banner.Image ? `url(data:image/png;base64,${banner.Image})` : 'none',
                backgroundSize: 'cover', 
                backgroundPosition: 'center', 
                position: 'relative', 
              }}
            >
              <CardContent sx={{ position: 'absolute', bottom: '20px', left: '20px' }}>
                {/* Any text/content you want to display can go here */}
              </CardContent>
            </Card>
          </SwiperSlide>
        ))}
      </Swiper>
    </Box>
  );
};

export default BannersMobile;
